

import http from "./http";

export const getFolders = async (school_id) => {
  return (await http.post(`school/file_manager?action=get_folders&school_id=${school_id}`)).data;
};

export const createFolder = async (data) => {
  const formData = new FormData();
  formData.append("school_id", data.school_id);
  formData.append("name", data.name);
  return (await http.post("school/file_manager?action=create_folder", formData)).data;
};

export const uploadFiles = async (data) => {
  const formData = new FormData();
  formData.append("school_id", data.school_id);
  formData.append("folder_id", data.folder_id);
  data.files.forEach(file => formData.append("files[]", file));
  return (await http.post("school/file_manager?action=upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  })).data;
};

// Fixed: Uses GET and 'id' as per your screenshots
export const deleteFolder = async (id) => {
  return (await http.get(`school/file_manager?action=delete_folder&id=${id}`)).data;
};

// Fixed: Uses GET and 'id' as per your screenshots
export const deleteFile = async (id) => {
  return (await http.get(`school/file_manager?action=delete_file&id=${id}`)).data;
};

export const downloadFile = async (file_id) => {
  // API per Postman screenshot: POST with query params (action=download_file&id)
  return http.post(
    `school/file_manager?action=download_file&id=${file_id}`,
    null,
    { responseType: "arraybuffer" }
  );
};

export const downloadFolder = async (folder_id) => {
  // API per Postman screenshot: POST with query params (action=download_folder_zip&folder_id)
  return http.post(
    `school/file_manager?action=download_folder_zip&folder_id=${folder_id}`,
    null,
    { responseType: "arraybuffer" }
  );
};

export const getSchoolExcelUrl = (school_id) => {
  return `https://sramidcard.in/api/school/school_excel.php?school_id=${school_id}`;
};

export const getTeacherExcelUrl = (school_id) => {
  return `https://sramidcard.in/api/school/teacher_excel.php?school_id=${school_id}`;
};

